"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdApollo = require("cccisd-apollo");
var _Formula = require("./Formula");
var _processFormulaChanges = _interopRequireDefault(require("./processFormulaChanges.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var ACTION_UPDATE = 'update';
var ACTION_REMOVE = 'remove';
var processFormulaChanges = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(changedValues, data, currentAssignmentId, setLoading) {
    var metrics, result;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          metrics = changedValues.map(function (changedValue) {
            var dataRow = data.find(function (item) {
              return item.variableId === changedValue.variableId && item.reportHeader !== changedValue.reportHeader && item.formulaInput !== null;
            });
            if (!dataRow) {
              return null;
            }
            return {
              variableId: dataRow.variableId,
              assignmentId: currentAssignmentId,
              formulaInput: dataRow.formulaInput,
              oldReportHeader: dataRow.reportHeader,
              newReportHeader: changedValue.reportHeader
            };
          }).filter(function (item) {
            return !!item;
          }).reduce(function (combined, current) {
            var key = "".concat(current.newReportHeader);
            var oldReportHeaders = combined[key] ? [].concat(_toConsumableArray(combined[key].oldReportHeaders), [current.oldReportHeader]) : [current.oldReportHeader];
            var variableIds = combined[key] ? [].concat(_toConsumableArray(combined[key].variableIds), [current.variableId]) : [current.variableId];
            var formulaInputs = combined[key] ? [].concat(_toConsumableArray(combined[key].formulaInputs), _toConsumableArray(current.formulaInput)) : current.formulaInput;
            delete current.oldReportHeader;
            delete current.variableId;
            delete current.formulaInput;
            return _objectSpread(_objectSpread({}, combined), {}, _defineProperty({}, key, _objectSpread(_objectSpread({}, current), {}, {
              oldReportHeaders: oldReportHeaders,
              variableIds: variableIds,
              formulaInputs: formulaInputs
            })));
          }, {});
          _context.n = 1;
          return loop(Object.values(metrics), setLoading);
        case 1:
          result = _context.v;
          return _context.a(2, result);
      }
    }, _callee);
  }));
  return function processFormulaChanges(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var loop = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(metrics, setLoading) {
    var allChangedMetricIds, changedFormulas, count, _loop, i;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          allChangedMetricIds = metrics.reduce(function (combined, current) {
            return [].concat(_toConsumableArray(combined), _toConsumableArray(current.variableIds));
          }, []);
          changedFormulas = [];
          count = metrics.length;
          _loop = /*#__PURE__*/_regenerator().m(function _loop() {
            var metric, oldInputOtherFormula, newInputOtherFormula, current, oldInputOtherFormulas, newInputOtherFormulas, formulaNameInput, oldTypes, oldEquationIfThenTypes, oldChangedToAnotherName, forceRemoveEquationIfThenTypes, confirmDisabled, action;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  metric = metrics[i - 1];
                  setLoading(true);
                  _context2.n = 1;
                  return getOldInputOtherFormula(metric);
                case 1:
                  oldInputOtherFormula = _context2.v;
                  _context2.n = 2;
                  return getNewInputOtherFormula(metric);
                case 2:
                  newInputOtherFormula = _context2.v;
                  setLoading(false);
                  current = oldInputOtherFormula.find(function (item) {
                    return metric.variableIds.includes(item.variableId);
                  });
                  oldInputOtherFormulas = !!oldInputOtherFormula.find(function (item) {
                    return !allChangedMetricIds.includes(item.variableId);
                  });
                  newInputOtherFormulas = !!newInputOtherFormula.find(function (item) {
                    return !allChangedMetricIds.includes(item.variableId);
                  });
                  formulaNameInput = current ? current.formulaNameInput.split(',') : [];
                  oldTypes = oldInputOtherFormula.reduce(function (combined, curr) {
                    if (!allChangedMetricIds.includes(curr.variableId)) {
                      return combined;
                    }
                    curr.formulaTypeInput.split(',').forEach(function (type) {
                      return combined.push(type);
                    });
                    return _toConsumableArray(new Set(combined));
                  }, []);
                  oldEquationIfThenTypes = oldTypes.filter(function (type) {
                    return type === _Formula.EQUATION || type === _Formula.IF_THEN;
                  });
                  oldChangedToAnotherName = !!metrics.find(function (m) {
                    return m.newReportHeader !== metric.newReportHeader && metric.oldReportHeaders.filter(function (h) {
                      return m.oldReportHeaders.includes(h);
                    }).length > 0;
                  });
                  forceRemoveEquationIfThenTypes = (oldInputOtherFormulas || oldChangedToAnotherName) && oldEquationIfThenTypes.length > 0;
                  confirmDisabled = forceRemoveEquationIfThenTypes && oldTypes.length === oldEquationIfThenTypes.length;
                  _context2.n = 3;
                  return ask(i, count, metric, oldInputOtherFormulas, newInputOtherFormulas, formulaNameInput, confirmDisabled, forceRemoveEquationIfThenTypes);
                case 3:
                  action = _context2.v;
                  changedFormulas.push(_objectSpread(_objectSpread({}, metric), {}, {
                    action: action,
                    forceRemoveEquationIfThenTypes: forceRemoveEquationIfThenTypes
                  }));
                case 4:
                  return _context2.a(2);
              }
            }, _loop);
          });
          i = 1;
        case 1:
          if (!(i <= count)) {
            _context3.n = 3;
            break;
          }
          return _context3.d(_regeneratorValues(_loop()), 2);
        case 2:
          i++;
          _context3.n = 1;
          break;
        case 3:
          return _context3.a(2, changedFormulas);
      }
    }, _callee2);
  }));
  return function loop(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
var getOldInputOtherFormula = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(metric) {
    var response;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return _cccisdApollo.client.query({
            query: _processFormulaChanges["default"],
            variables: {
              groupId: metric.groupId,
              reportHeader: metric.oldReportHeaders
            },
            fetchPolicy: 'network-only'
          });
        case 1:
          response = _context4.v;
          return _context4.a(2, response.data.metrics.variableList);
      }
    }, _callee3);
  }));
  return function getOldInputOtherFormula(_x7) {
    return _ref3.apply(this, arguments);
  };
}();
var getNewInputOtherFormula = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(metric) {
    var response;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return _cccisdApollo.client.query({
            query: _processFormulaChanges["default"],
            variables: {
              groupId: metric.groupId,
              reportHeader: [metric.newReportHeader]
            },
            fetchPolicy: 'network-only'
          });
        case 1:
          response = _context5.v;
          return _context5.a(2, response.data.metrics.variableList);
      }
    }, _callee4);
  }));
  return function getNewInputOtherFormula(_x8) {
    return _ref4.apply(this, arguments);
  };
}();
var ask = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(index, count, metric, oldInputOtherFormulas, newInputOtherFormulas, formulaNameInput, confirmDisabled, forceRemoveEquationIfThenTypes) {
    var uniqueOldReportHeaders, oldReportHeader, thisMetricUpper, thisMetric, is, buttonMetric, thisFormula, aboveFormula, buttonFormula, of, forceRemoveEquationIfThenTypesMsg, oldInputOtherFormulasMsg, newInputOtherFormulasMsg, result;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          uniqueOldReportHeaders = Object.values(metric.oldReportHeaders.reduce(function (comb, curr) {
            return _objectSpread(_objectSpread({}, comb), {}, _defineProperty({}, curr, curr));
          }, {}));
          oldReportHeader = "\"".concat(uniqueOldReportHeaders.join('", "'), "\"");
          thisMetricUpper = uniqueOldReportHeaders.length > 1 ? 'These metrics' : 'This metric';
          thisMetric = uniqueOldReportHeaders.length > 1 ? 'these metrics' : 'this metric';
          is = uniqueOldReportHeaders.length > 1 ? 'are' : 'is';
          buttonMetric = uniqueOldReportHeaders.length > 1 ? 'metrics' : 'metric';
          thisFormula = formulaNameInput.length > 1 ? 'these formulas' : 'this formula';
          aboveFormula = formulaNameInput.length > 1 ? 'above formulas' : 'above formula';
          buttonFormula = formulaNameInput.length > 1 ? 'formulas' : 'formula';
          of = count > 1 ? "(".concat(index, " of ").concat(count, ")") : '';
          forceRemoveEquationIfThenTypesMsg = /*#__PURE__*/_react["default"].createElement("p", {
            style: {
              marginTop: '10px'
            }
          }, "Note: there are other metrics also named ", oldReportHeader, " that are part of Equation or If/Then formulas. These formulas can not be updated. To update Equation and If/Then formulas rename all instances of", ' ', oldReportHeader, " metric to the same new name.");
          oldInputOtherFormulasMsg = /*#__PURE__*/_react["default"].createElement("p", {
            style: {
              marginTop: '10px'
            }
          }, "Note: there are other metrics also named ", oldReportHeader, " that are part of ", thisFormula, ". They will remain unchanged regardless of the choice selected below.");
          newInputOtherFormulasMsg = /*#__PURE__*/_react["default"].createElement("p", {
            style: {
              marginTop: '10px'
            }
          }, "Note: there are other metrics also named ", metric.newReportHeader, " that are part of ", thisFormula, ". They will remain unchanged regardless of the choice selected below.");
          _context6.n = 1;
          return new Promise(function (resolve) {
            (0, _cccisdConfirm["default"])({
              message: "Renaming ".concat(oldReportHeader, " to \"").concat(metric.newReportHeader, "\" ").concat(of),
              description: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, thisMetricUpper, " ", is, " part of ", thisFormula, ":", /*#__PURE__*/_react["default"].createElement("ul", null, formulaNameInput.map(function (item) {
                return /*#__PURE__*/_react["default"].createElement("li", {
                  key: item
                }, item);
              })), "Would you like to update the ", aboveFormula, " to use ", thisMetric, " with the new name, or would you like to remove ", thisMetric, " from ", thisFormula, "?", oldInputOtherFormulas && !confirmDisabled && oldInputOtherFormulasMsg, newInputOtherFormulas && !confirmDisabled && newInputOtherFormulasMsg, forceRemoveEquationIfThenTypes && forceRemoveEquationIfThenTypesMsg),
              confirmLabel: "Update ".concat(buttonFormula),
              confirmDisabled: confirmDisabled,
              abortLabel: 'Cancel',
              confirmation: ACTION_UPDATE,
              additionalConfirmButtons: [{
                confirmLabel: "Remove ".concat(buttonMetric, " from ").concat(buttonFormula),
                confirmation: ACTION_REMOVE
              }]
            }).then(function (confirmation) {
              resolve(confirmation);
            });
          });
        case 1:
          result = _context6.v;
          return _context6.a(2, result);
      }
    }, _callee5);
  }));
  return function ask(_x9, _x0, _x1, _x10, _x11, _x12, _x13, _x14) {
    return _ref5.apply(this, arguments);
  };
}();
var _default = exports["default"] = processFormulaChanges;